(() => {
  if (typeof window.FaraMagazineSearch?.prepare === 'function') { window.FaraMagazineSearch.prepare(); return; }
  const instances = new Map();
  const archives = new Map();
  const normalise = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();

  function mount(root) {
    const input = root.querySelector('input[name="q"]');
    const form = root.matches('form') ? root : root.querySelector('form');
    const panel = root.querySelector('[data-magazine-results]');
    const list = root.querySelector('[data-magazine-suggestions]');
    const status = root.querySelector('[data-magazine-status]');
    const all = root.querySelector('[data-magazine-all]');
    const clear = root.querySelector('[data-magazine-clear]');
    if (!input || !form || !panel || !list || !status) return null;
    let blog, indexUrl;
    try {
      blog = new URL(root.dataset.blogUrl, location.href);
      if (blog.origin !== location.origin || !/^https?:$/.test(blog.protocol) || /%2f|%5c/i.test(blog.pathname)) return null;
      blog.pathname = blog.pathname.replace(/\/$/, '');
      blog.search = ''; blog.hash = '';
      indexUrl = requestUrl(root.dataset.indexUrl, 1);
    } catch { return null; }
    const cacheKey = indexUrl.href;
    const allLabel = all?.textContent || '';
    const cleanups = [];
    let disposed = false, generation = 0, timer, controller, archivePromise;
    let matches = [], shown = 0, expanded = false, matchedQuery = '';

    function requestUrl(value, page) {
      const url = new URL(value, location.href);
      if (url.origin !== blog.origin || url.pathname.replace(/\/$/, '') !== blog.pathname || /%2f|%5c/i.test(url.pathname)) throw new Error('Unexpected archive URL');
      if (url.searchParams.has('view') && url.searchParams.get('view') !== 'fara-search') throw new Error('Unexpected archive view');
      url.hash = '';
      url.search = '';
      url.searchParams.set('view', 'fara-search');
      url.searchParams.set('page', String(page));
      return url;
    }
    function article(item) {
      if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string' || !item.title.trim() || !Array.isArray(item.tags) || item.tags.some(tag => typeof tag !== 'string') || typeof item.excerpt !== 'string') throw new Error('Invalid article metadata');
      const url = new URL(item.url, location.href);
      const suffix = url.pathname.slice(blog.pathname.length + 1);
      if (url.origin !== blog.origin || !url.pathname.startsWith(blog.pathname + '/') || !suffix || suffix.includes('/') || /%2f|%5c/i.test(url.pathname)) throw new Error('Unexpected article URL');
      if (url.searchParams.has('view') && url.searchParams.get('view') !== 'fara-magazine') throw new Error('Unexpected article view');
      const title = normalise(item.title), tags = item.tags.map(normalise), excerpt = normalise(item.excerpt);
      return {id: String(item.id), title: item.title, url: url.href, tags: item.tags, titleKey: title, tagKeys: tags, excerptKey: excerpt};
    }
    async function loadArchive() {
      const cached = archives.get(cacheKey);
      if (cached && Date.now() - cached.time < 300000) return cached.items;
      if (archivePromise) return archivePromise;
      controller = new AbortController();
      const signal = controller.signal;
      archivePromise = (async () => {
        const found = new Map(), visited = new Set();
        let url = indexUrl, total, pages;
        for (let page = 1; ; page++) {
          if (disposed || signal.aborted || page > 250 || visited.has(url.href)) throw new Error('Incomplete archive');
          visited.add(url.href);
          const timeout = setTimeout(() => controller?.abort(), 10000);
          let data;
          try {
            const response = await fetch(url.href, {credentials: 'same-origin', signal, headers: {Accept: 'application/json'}});
            if (!response.ok || response.url && new URL(response.url).origin !== blog.origin) throw new Error('Archive request failed');
            data = await response.json();
          } finally { clearTimeout(timeout); }
          if (disposed || signal.aborted) throw new Error('Archive request cancelled');
          if (!data || data.page !== page || !Number.isSafeInteger(data.total) || data.total < 0 || !Number.isSafeInteger(data.pages) || data.pages < 0 || data.pages > 250 || !Array.isArray(data.articles) || data.articles.length > 100 || new URL(data.blog, location.href).href !== blog.href) throw new Error('Invalid archive page');
          if (page === 1) { total = data.total; pages = Math.max(1, data.pages); }
          if (data.total !== total || Math.max(1, data.pages) !== pages) throw new Error('Archive changed during search');
          data.articles.forEach(item => { const entry = article(item); found.set(entry.id, entry); });
          if (!data.next) {
            if (page !== pages || found.size !== total) throw new Error('Incomplete archive');
            const items = [...found.values()];
            archives.set(cacheKey, {time: Date.now(), items});
            return items;
          }
          if (page >= pages || new URL(data.next, location.href).searchParams.get('page') !== String(page + 1)) throw new Error('Invalid archive pagination');
          url = requestUrl(data.next, page + 1);
        }
      })().finally(() => { archivePromise = null; controller = null; });
      return archivePromise;
    }
    function listen(target, type, callback) {
      target.addEventListener(type, callback);
      cleanups.push(() => target.removeEventListener(type, callback));
    }
    function reset() {
      matches = []; shown = 0; expanded = false; matchedQuery = '';
      panel.hidden = true; list.replaceChildren(); panel.removeAttribute('aria-busy');
      if (all) all.hidden = true;
      if (clear) clear.hidden = !input.value;
      status.textContent = root.dataset.start || '';
    }
    function paint() {
      const fragment = document.createDocumentFragment();
      matches.slice(0, shown).forEach(item => {
        const li = document.createElement('li'), link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        li.append(link);
        if (item.tags.length) {
          const meta = document.createElement('span');
          meta.className = 'fara-magazine-search__tags';
          meta.textContent = item.tags.slice(0, 3).join(' / ');
          li.append(meta);
        }
        fragment.append(li);
      });
      list.replaceChildren(fragment);
      panel.hidden = false;
      panel.removeAttribute('aria-busy');
      const resultLabel = matches.length === 1 ? root.dataset.resultOne || root.dataset.results : root.dataset.results;
      status.textContent = matches.length ? (resultLabel || '').replace('[count]', String(matches.length)) : root.dataset.empty || '';
      if (all) {
        all.hidden = shown >= matches.length;
        all.textContent = expanded ? root.dataset.more || allLabel : allLabel;
      }
      if (clear) clear.hidden = !input.value;
    }
    async function search(showAll, token = ++generation) {
      clearTimeout(timer);
      const query = normalise(input.value);
      if (query.length < 2) { reset(); return; }
      panel.hidden = false; panel.setAttribute('aria-busy', 'true'); list.replaceChildren();
      if (all) all.hidden = true;
      if (clear) clear.hidden = false;
      status.textContent = root.dataset.searching || '';
      try {
        const items = await loadArchive();
        if (disposed || !root.isConnected || token !== generation) return;
        const terms = query.split(' ');
        matches = items.map((item, order) => {
          if (!terms.every(term => item.titleKey.includes(term) || item.tagKeys.some(tag => tag.includes(term)) || item.excerptKey.includes(term))) return null;
          let score = item.titleKey === query ? 1000 : item.titleKey.startsWith(query) ? 500 : item.titleKey.includes(query) ? 250 : 0;
          terms.forEach(term => { score += item.titleKey.includes(term) ? 50 : item.tagKeys.some(tag => tag.includes(term)) ? 20 : 1; });
          return {item, order, score};
        }).filter(Boolean).sort((a, b) => b.score - a.score || a.order - b.order).map(result => result.item);
        matchedQuery = query;
        expanded = showAll; shown = Math.min(matches.length, showAll ? 24 : 6);
        paint();
      } catch {
        if (disposed || !root.isConnected || token !== generation) return;
        matches = []; matchedQuery = ''; panel.hidden = false; panel.removeAttribute('aria-busy');
        list.replaceChildren(); status.textContent = root.dataset.error || '';
        if (all) all.hidden = true;
      }
    }
    function queue(event) {
      if (event?.isComposing) return;
      const token = ++generation;
      clearTimeout(timer);
      if (normalise(input.value).length < 2) { reset(); return; }
      timer = setTimeout(() => search(false, token), 180);
    }
    listen(input, 'input', queue);
    listen(input, 'compositionend', queue);
    listen(form, 'submit', event => {
      if (event.defaultPrevented) return;
      event.preventDefault(); search(true);
    });
    listen(root, 'click', event => {
      const control = event.target.closest('[data-magazine-clear],[data-magazine-all],[data-magazine-topic]');
      if (!control || !root.contains(control) || control.disabled) return;
      event.preventDefault();
      if (control.hasAttribute('data-magazine-clear')) {
        generation++; clearTimeout(timer); input.value = ''; reset(); input.focus();
      } else if (control.hasAttribute('data-magazine-topic')) {
        input.value = control.dataset.query || ''; input.focus(); search(true);
      } else if (matchedQuery === normalise(input.value)) {
        const previousShown = shown;
        generation++; expanded = true; shown = Math.min(matches.length, shown < 24 ? 24 : shown + 24);
        paint();
        if (all?.hidden) list.children[Math.min(previousShown, shown - 1)]?.querySelector('a')?.focus({preventScroll: true});
      } else search(true);
    });
    listen(root, 'keydown', event => {
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing || event.metaKey || event.ctrlKey || event.altKey || panel.hidden) return;
      event.preventDefault(); generation++; clearTimeout(timer); panel.hidden = true; panel.removeAttribute('aria-busy');
      input.focus();
    });
    reset();
    return {dispose() {
      if (disposed) return;
      disposed = true; generation++; clearTimeout(timer); controller?.abort();
      cleanups.forEach(cleanup => cleanup()); instances.delete(root);
    }};
  }
  function prepare() {
    for (const [root, instance] of instances) if (!root.isConnected) instance.dispose();
    document.querySelectorAll('[data-fara-magazine-search]').forEach(root => {
      if (instances.has(root)) return;
      const instance = mount(root);
      if (instance) instances.set(root, instance);
    });
  }
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) if (event.target === root || event.target.contains?.(root)) instance.dispose();
  });
  window.addEventListener('fara:before-navigate', () => { for (const instance of instances.values()) instance.dispose(); });
  window.FaraMagazineSearch = {prepare};
  prepare();
})();
